<template>
  <div class="list-container">
    <div class="icon">
      <i class="material-icons">{{icon}}</i>
    </div>
    <div class="item-container">
      <div class="title">{{title}}</div>
      <div class="subtitle">{{secondTitle}}</div>
      <div class="subtitle">{{thirdTitle}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventDetailsListItem',
  props: {
    title: {
      type: String,
      default: ''
    },
    secondTitle: {
      type: String,
      default: ''
    },
    thirdTitle: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.list-container {
  display: flex;
  padding-bottom: 10px;
  margin-right: 40px;
}
.item-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.item-container > .title {
  font-size: 14px;
  font-weight: 600;
}
.subtitle {
  font-size: 14px;
  opacity: .7;
  padding-right: 20px;
}
.icon {
  min-width: 35px;
  padding-top: 5px;
  color: #3F51B5;
  opacity: .8;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/EventDetailsListItem.vue